import { Component, OnDestroy, TemplateRef, ViewChild, ViewEncapsulation, OnInit } from '@angular/core';
import { FormBuilder, FormGroup,  NgForm } from '@angular/forms';

import { DataSource } from '@angular/cdk/collections';
import { Observable, Subject } from 'rxjs';
import { takeUntil, timeInterval } from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import *  as $ from 'jquery';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from 'app/main/pagina/modal/modal.component';
import { ProgramacionN35Service} from 'app/main/wizard-n35encuestador/services/programacionn35.service';
import { WizardN35EncuestadorService } from 'app/main/wizard-n35encuestador/services/wizardn35encuestador.services';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import { MatSnackBar } from "@angular/material/snack-bar";
import { Cierren35Service } from 'app/main/wizard-n35encuestador/services/cierren35.service';
import Swal from 'sweetalert2';
import * as backClose from './shedulesurvey35.interface';
const moment = require('moment');
const momentTz = require('moment-timezone');

interface adverModal {
  tipo: number;
  mensaje: string;
  diccionario: string;
  confirma: boolean;
};
import { Formadialog35Component} from 'app/main/pagina/encuestador-n35/shedulesurvey35/formadialog35/formadialog35.component';

//SERVICE // VERIFICAR
import { Shedule35Service } from "../services/shedule35.service";

///IDIOMAS
import { lang_shedule } from 'app/idiomas/i18n/shedule35/shedule35.lang';
import { lang_shedule as shedCert} from 'app/idiomas/i18n/shedule/shedule.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import {FormControl,  Validators} from '@angular/forms';
import { objetoMenos50 } from './shedulesurvey35.interface';


@Component({
  selector: 'shedulesurvey35',
  templateUrl: './shedulesurvey35.component.html',
  styleUrls: ['./shedulesurvey35.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations   : fuseAnimations
})
export class Shedulesurvey35Component implements OnInit {
  idiomaActual:string;
  mensajesTraducirKeys: string[] = [
    'SHEDULE.ERROR1',
    'SHEDULE.ERROR2',
    'SHEDULE.ERROR3',
    'SHEDULE.ERROR4',
    'SHEDULE.ERROR5',
    'SHEDULE.MSJ1',
    'SHEDULE.MSJ2',
    'SHEDULE.MSJ3',
    'SHEDULE.MSJ4',
    'SHEDULE.MSJ5',
    'SHEDULE.MSJ6',
    'SHEDULE.MSJ7',
    'SHEDULE.MSJ8',
    'SHEDULE.MSJ9',
    'SHEDULE.MSJ10',
    'SHEDULE.MSJ11',
    'SHEDULE.MSJ12',
    'SHEDULE.MSJ13',
    'SHEDULE.MSJ14',
    'SHEDULE.MSJ15',
    'SHEDULE.SAMEDATE'
  ];

  mensajesTraducirTS = {
    error1: '',
    error2: '',
    error3:'',
    error4:'',
    error5:'',
    msj1:'',
    msj2:'',
    msj3:'',
    msj4:'',
    msj5:'',
    msj6:'',
    msj7:'',
    msj8:'',
    msj9:'',
    msj10:'',
    msj11:'',
    msj12:'',
    msj13:'',
    msj14:'',
    msj15:'',
    error6: ''
  };
  fechaLanzamiento: any;
  fechaCierre: any;
  remaindStatus = false;
  dateStatus=false;
  centered = false;
  disabled = false;
  unbounded = false;
  showButtonInstitute: boolean = true;
  show: boolean = true;
  showCierre: boolean = true;
  form: FormGroup;
  idLanzamiento: string = "";
  labelDate: string = '';
  labelDate2: string = '';
  labelCierre: string = '';
  labelRecordatorio1: string = '';
  labelRecordatorio2: string = '';
  labelRecordatorio3: string = '';
  labelRecordatorio4: string = '';
  labelRecordatorio5: string = '';
  radius: number;
  color: string;
  dialogRef: any;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
  expPanel:boolean=false;

  // Datos certificar vigente
  productoCertificar: backInter.prodCert;
  productoCertificar35: backInter.prodNorma35;
  fechaCertificar35: any;
  //boolean paso completo
  pasoCompleto = false;
  arrayRecordatorios: any;
  statusFecha=false;
  statusTipo=false;
  statusTipo2=false;
  pilotSurvey=false;

  idEmpresa: string;

  //booleans status
  encuestaOk: boolean;
  mas50Ok: boolean;
  menos50Ok: boolean;
  usuariosOk: boolean;


  constructor(
    private _formBuilder: FormBuilder,
    public dialog: MatDialog,
    private service : Shedule35Service,
    private programacionService: ProgramacionN35Service,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    public snackBar: MatSnackBar,
    private translateSrv: TranslateService,
    private wizardService: WizardN35EncuestadorService,
    private serviceClose : Cierren35Service,
  ){
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
    lang_shedule.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });
    shedCert.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    if(localStorage.getItem('instituto') == '1'){
      this.showButtonInstitute = false;
    }else{
      this.showButtonInstitute = true;
    }


  }
  ngOnInit() {
    this.traduceTextosTS();
    $(document).ready(function(){
      $(".finishBt").width($(".finishBt").parent().width());
    });
    $(window).resize(function(){
      $(".finishBt").width($(".finishBt").parent().width());
    });
    this.idEmpresa = this.programacionService.getIdEmpresa();
    this.obtieneCertificarActual35();

    this.form = this._formBuilder.group({
      email01: ['', Validators.compose([
        Validators.minLength(5),
        Validators.required
      ])],
      email02: ['', Validators.compose([
        Validators.minLength(5),
        Validators.required
      ])],
      email03: ['', Validators.compose([
        Validators.minLength(5),
        Validators.required
      ])],
      email04: ['', Validators.compose([
        Validators.minLength(5),
        Validators.required
      ])],
      email05: ['', Validators.compose([
        Validators.minLength(5),
        Validators.required
      ])],
    });
  }
  obtieneCertificarActual35(){
    /// obtiene el producto certificar vigente
    this.programacionService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
            this.fechaCertificar35=producto.fechaNorma35;
            this.getRecordatoriosFechas();
            if(producto.completoNorma35 === 1){
              this.productoCertificar35 = producto;
              throw BreakException;
            }
          }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      this.programacionService.getStatu(this.productoCertificar35.idNorma35,true).subscribe( (data: backInter.getStatusIndiv) => {
        if(data.estatus === 3){
          this.pasoCompleto = true;
        }
      });

      // this.generaURL();
      //obtiene las preguntas adicionales guardadas
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });

  }



  completarPaso(){
    this.traduceTextosTS();
    if(this.pasoCompleto && this.pilotSurvey){
      this.aletaRestric('PROGRAMACION.COMPLETADO');
    }else if(this.dateStatus == false){
      this.mensajeSwal(this.mensajesTraducirTS.msj4, 2);
    }else{
      if(!this.pilotSurvey){
        Swal.fire(
          ' '+this.mensajesTraducirTS.msj9,
          '',
          'error'
        )
      }else{
        this.aletaRestric('PROGRAMACION.COMPLETAR',true);
      }

    }
  }
  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }
  aletaRestric(mensaje:string,confirmar?:boolean){
    let infoModal: adverModal = {'tipo': 3, 'confirma': confirmar, 'mensaje': mensaje, 'diccionario': 'WIZARD.CERTIFICAR.'};
    //const confirmaMod = this.dialog.open(ModalComponent, { data:infoModal });
    if(confirmar){
      this.programacionService.saveStatus(this.productoCertificar35.idNorma35).subscribe( (data: backInter.RespuestaGen) => {
        if(data.message == '215'){
          Swal.fire(
            this.mensajesTraducirTS.msj7,
            '',
            'success'
          );
          // Falta poner modal sweet
          this.aletaRestric('PROGRAMACION.'+data.message);
          this.pasoCompleto = true;
          this.enviaOrdenWizard();
        };
      });
    }
  }
  resultFinal:any;
  flagEnvios:any;
  flagEnvios_second:any;
  Progenvios:any;
  recordatorio1:any;
  recordatorio2:any;
  recordatorio3:any;
  recordatorio4:any;
  recordatorio5:any;

  addDate(aux: number): void
  {
    this.dialogRef = this.dialog.open(Formadialog35Component, {
      data: {}
    });
    this.dialogRef.afterClosed()
      .subscribe(result => {
        var date = new Date(result),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
        var now = new Date();
        var date2 = new Date(now),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
        var moment = require('moment');
        var newnow = moment(now).format('MM/DD/YYYY');
        var newresult = moment(result).format('MM/DD/YYYY');
        // Esta es la nueva función para agregar recordatorios
        if(aux == 1){
          console.log(localStorage.getItem('instituto'));

          if(localStorage.getItem('instituto') == '1' || localStorage.getItem('instituto') == 'MX'){
            console.log("NEw "+newresult);
            this.flagEnvios=this.diferenciaEntreDiasEnDias(newresult,newnow,aux,mnth,day,result);
            /*if(moment(result).format('MM/DD/YYYY') != moment().format('MM/DD/YYYY')){
              this.flagEnvios=this.diferenciaEntreDiasEnDias(newresult,newnow,aux,mnth,day,result);
            }
            else{
              Swal.fire({
                title: this.mensajesTraducirTS.error6,
                icon: 'warning',
                confirmButtonColor: '#e40601'
              });
            }*/
          }
          else{
            this.flagEnvios=this.diferenciaEntreDiasEnDias(newresult,newnow,aux,mnth,day,result);
          }
        }
        else{
          this.flagEnvios=this.diferenciaEntreDiasEnDias(newresult,newnow,aux,mnth,day,result);
        }
    });
  }

  private registerDate(fecha,recordatorio1,recordatorio2,recordatorio3,recordatorio4,recordatorio5,status,recordatorio6,recordatrio7){
      Swal.fire({
        title: this.mensajesTraducirTS.msj1,
        text: this.mensajesTraducirTS.msj2+" ",
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.mensajesTraducirTS.msj3,
        cancelButtonText: this.mensajesTraducirTS.msj8,

      }).then((result) => {
        if (result.value) {
          Swal.fire(
            ' '+this.mensajesTraducirTS.msj5,
            '',
            'success'
          )
      let dataEnc={
        'fechaNorma35' : this.fechaCertificar35,
        'fechaLanzamiento' : fecha,
        'productoId' : localStorage.getItem('productoID'),
      };
      // TEMPORAL

      // FIN TEMPORAL
        this.service.registerDateBegin(dataEnc)
          .subscribe(response => {
            if(response['message'] == '221'){
              //this.openSuccessSnackBar('Launch Date Registered Successfully','OK');
              this.idLanzamiento = response['programacion']['_id'];
              this.fechaLanzamiento = response['programacion']['fechaLanzamiento'];
              this.show = false;
              if(status == true){
                this.registerRecordatorio_menos30(recordatorio3,recordatorio4,recordatorio5,this.idLanzamiento);
              }else{
                this.registerRecordatorio_mas30(recordatorio1,recordatorio2,recordatorio3,recordatorio4,recordatorio5,this.idLanzamiento,recordatorio6,recordatrio7);
              }
          }
        }, error => {
            //console.log(error);
        });

        }
      })
  }

  private registerDateRest(fecha,recordatorio3,recordatorio4,recordatorio5,status){

    let fechaAux=recordatorio3.toString();
    var d = new Date(recordatorio3);
    let fechaFinal = d.getFullYear()+' - '+d.getMonth()+' - '+(d.getDate()+1);
    Swal.fire({
      title: this.mensajesTraducirTS.msj1,
      text: this.mensajesTraducirTS.msj2,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.mensajesTraducirTS.msj3,
      cancelButtonText: this.mensajesTraducirTS.msj8
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          ''+this.mensajesTraducirTS.msj5,
          '',
          'success'
        )
    let dataEnc={
      'fechaNorma35' : this.fechaCertificar35,
      'fechaLanzamiento' : fecha,
      'productoId' : localStorage.getItem('productoID'),
    };
    // TEMPORAL
      this.service.registerDateBegin(dataEnc)
        .subscribe(response => {
          if(response['message'] == '221'){
            //this.openSuccessSnackBar('Launch Date Registered Successfully','OK');
            this.idLanzamiento = response['programacion']['_id'];
            this.fechaLanzamiento = response['programacion']['fechaLanzamiento'];
            this.show = false;
            this.registerRecordatorio_menos30(recordatorio3,recordatorio4,recordatorio5,this.idLanzamiento);
        }
      }, error => {
          //console.log(error);
      });

      }
    })
}

  private registerClose(fecha){
     if(this.idLanzamiento.length > 0){
       let data={
            'fechaCertificar' : localStorage.getItem('fechaProducto'),
            'idProgramacion' : this.idLanzamiento,
            'fechaCierre' : fecha
         };

         this.service.registerCierre(data)
           .subscribe(response => {
              if(response['message'] == '220'){
                 //this.openSuccessSnackBar('Cierre registrado correctamente','OK');
                 this.showCierre = false;
               }
             }, error => {
               //console.log(error);
             });
     }else{
       this.labelRecordatorio1 = '';
       this.openErrorSnackBar('Antes de registrar cierr, tiene que registrar la fecha de Lanzamiento','OK');
     }
   }

 private registerRecordatorio(fecha,idLanzamiento){
    if(idLanzamiento.length >0){
      let data={
        'fechaNorma35' : this.fechaCertificar35,
        'fechaRecordatorio' : fecha,
        'idProgramacion' : idLanzamiento,
        'productoId' : localStorage.getItem('productoID'),
      };
      this.service.registerDateBegin(data)
        .subscribe(response => {
          if(response['message'] == '220'){

          }
        }, error => {
          console.log(error);
        });
    }else{
      this.labelRecordatorio1 = '';
      this.openErrorSnackBar('Antes de registrar un recordatorio tiene que registrar la fecha de Lanzamiento','OK');
    }
  }

  private registerRecordatorio_menos30(fecha1,fecha2,fecha3,idLanzamiento){
    if(idLanzamiento.length >0){
      let data1={
        'fechaNorma35' : this.fechaCertificar35,
        'fechaRecordatorio' : fecha1,
        'idProgramacion' : idLanzamiento,
        'productoId' : localStorage.getItem('productoID'),
      };

      let data2={
        'fechaNorma35' : this.fechaCertificar35,
        'fechaRecordatorio' : fecha2,
        'idProgramacion' : idLanzamiento,
        'productoId' : localStorage.getItem('productoID'),
      };

      let data3={
        'fechaNorma35' : this.fechaCertificar35,
        'fechaRecordatorio' : fecha3,
        'idProgramacion' : idLanzamiento,
        'productoId' : localStorage.getItem('productoID'),
      };
      this.service.registerDateBegin(data1)
        .subscribe(response => {
          if(response['message'] == '220'){
            this.service.registerDateBegin(data2)
            .subscribe(response => {
                if(response['message'] == '220'){
                  //FECHA 2
                  this.service.registerDateBegin(data3)
                    .subscribe(response => {
                        if(response['message'] == '220'){
                          this.getRecordatoriosFechas();
                        }
                  });
                  // FIN FECHA 2
                }
            });

          }
        }, error => {
          console.log(error);
        });
    }else{
      this.labelRecordatorio1 = '';
      this.openErrorSnackBar('Antes de registrar un recordatorio tiene que registrar la fecha de Lanzamiento','OK');
    }
  }

  private registerRecordatorio_mas30(fecha1,fecha2,fecha3,fecha4,fecha5,idLanzamiento,fecha6,fecha7){
    if(idLanzamiento.length >0){
      let data1={
        'fechaNorma35' : this.fechaCertificar35,
        'fechaRecordatorio' : fecha1,
        'idProgramacion' : idLanzamiento,
        'productoId' : localStorage.getItem('productoID'),
      };

      let data2={
        'fechaNorma35' : this.fechaCertificar35,
        'fechaRecordatorio' : fecha2,
        'idProgramacion' : idLanzamiento,
        'productoId' : localStorage.getItem('productoID'),
      };

      let data3={
        'fechaNorma35' : this.fechaCertificar35,
        'fechaRecordatorio' : fecha3,
        'idProgramacion' : idLanzamiento,
        'productoId' : localStorage.getItem('productoID'),
      };

      let data4={
        'fechaNorma35' : this.fechaCertificar35,
        'fechaRecordatorio' : fecha4,
        'idProgramacion' : idLanzamiento,
        'productoId' : localStorage.getItem('productoID'),
      };

      let data5={
        'fechaNorma35' : this.fechaCertificar35,
        'fechaRecordatorio' : fecha5,
        'idProgramacion' : idLanzamiento,
        'productoId' : localStorage.getItem('productoID'),
      };

      let data6={
        'fechaNorma35' : this.fechaCertificar35,
        'fechaRecordatorio' : fecha6,
        'idProgramacion' : idLanzamiento,
        'productoId' : localStorage.getItem('productoID'),
      };

      let data7={
        'fechaNorma35' : this.fechaCertificar35,
        'fechaRecordatorio' : fecha7,
        'idProgramacion' : idLanzamiento,
        'productoId' : localStorage.getItem('productoID'),
      };
      this.service.registerDateBegin(data1)
        .subscribe(response => {
          if(response['message'] == '220'){
            // Fecha 2
            if(response['message'] == '220'){
              this.service.registerDateBegin(data2)
            .subscribe(response => {
              // Fecha 3
              if(response['message'] == '220'){
                this.service.registerDateBegin(data3)
                .subscribe(response => {
                  if(response['message'] == '220'){
                    //Fecha 4
                  this.service.registerDateBegin(data4)
                  .subscribe(response => {
                    // Fecha 5
                      this.service.registerDateBegin(data5)
                    .subscribe(response => {
                        if(response['message'] == '220'){
                          // this.getRecordatoriosFechas();

                          this.service.registerDateBegin(data6)
                            .subscribe(response => {

                              if(response['message'] == '220'){

                                this.service.registerDateBegin(data7)
                                .subscribe(response => {
                                  if(response['message'] == '220'){
                                    this.getRecordatoriosFechas();

                                  }

                                });

                              }

                            }); // Fin fecha 6

                        }
                      });
                    // Fin fecha 5
                  });
                  }//Fin fecha 4
                });
              }// Fin fecha 3
            });
            }// Fin fecha 2
          }
        }, error => {
          console.log(error);
        });
    }else{
      this.labelRecordatorio1 = '';
      this.openErrorSnackBar('Antes de registrar un recordatorio tiene que registrar la fecha de Lanzamiento','OK');
    }
  }


  getFechaLanzamiento35(){
    let data={
          'fechaNorma35' : this.fechaCertificar35
      };
      console.log(data);
      this.service.getFechaLanzamiento35(data)
        .subscribe(response => {
          if(response['message'] == '200'){
            console.log(response);
            this.idLanzamiento = response['idFechaLanzamiento'];
            this.labelDate = response['fechaLanzamiento'];
            console.log("Fecha de cierre");
            console.log(response['fechaCierre']);
            let aux: string = '';
            if(response.hasOwnProperty('fechaCierre')){
              this.labelCierre = response['fechaCierre'];
              this.Cierrelabel = response['fechaCierre'];
              var dateCierre = new Date(this.labelCierre);
              this.labelCierre = dateCierre.getFullYear()+' - '+dateCierre.getMonth()+' - '+(dateCierre.getDate()+1);
              this.showCierre = false;
            }
            this.show = false;
            var d = new Date(this.labelDate);
            //this.labelDate = d.getFullYear()+' - '+d.getMonth()+' - '+(d.getDate()+1);
            let fechaDeLanzamiento=this.labelDate.toString();
            console.log(fechaDeLanzamiento.substr(0,10));
            this.labelDate=fechaDeLanzamiento.substr(0,10);
          }
      }, error => {
        console.log(error);
      });
  }

  openErrorSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
         duration: 60000,
         verticalPosition: 'top',
         panelClass: ['background-red']
      });
   }
   openSuccessSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
         duration: 60000,
         verticalPosition: 'top',
         panelClass: ['background-success']
      });
   }

    TotalDias:any;
    //Este es el segundo paso para agregar una fecha
   diferenciaEntreDiasEnDias(a, b,aux,mnth,day,result)
  {

    let auxRresult=result;
    const moment = require('moment');
    var timestamp1 = new Date(a).getTime();
    var timestamp2 = new Date(b).getTime();
    var diff =  timestamp1 - timestamp2 ;
    this.TotalDias =  Math.round(diff/86400000);
    if(this.TotalDias<0){
      this.obtenerIdioma('error1');
    }else if(this.TotalDias<30){
      Swal.fire({
        title: ""+this.mensajesTraducirTS.error3,
        text: ""+this.mensajesTraducirTS.error4,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: ''+this.mensajesTraducirTS.error5,
        cancelButtonText: this.mensajesTraducirTS.msj8
      }).then((result) => {
        if (result.value) {
          this.agregarFechaRest(auxRresult,a,b,aux);
        }
      })
    }else{
      this.agregarFecha(result,a,b,aux); // Funciona bien
    }
  }


  recordatorio6:any;
  recordatorio7:any;
  agregarFecha(result,newresult,newnow,aux){
    var date = new Date(result),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
      var now = new Date();
      var date2 = new Date(now),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
      var moment = require('moment');
      var newnow = moment(now).format('MM/DD/YYYY');
      var newresult = moment(result).format('MM/DD/YYYY');
      if(result != null){
        this.recordatorio1=this.recordatorio_aviso1(result,30); // 30 días antes de la encuesta
        this.recordatorio2=this.recordatorio_aviso1(result,15); // 15 días antes de la encuesta
        this.recordatorio3=this.recordatorio_aviso1(result,0); // Lanzamiento de la encuesta
        this.recordatorio4=this.recordatorio_aviso2(result,21); //Fecha de cierre
        this.recordatorio5=this.recordatorio_aviso2(result,51); // REsultados
        // RECORDATORIO 29 DÍAS
        const mil = 86400000;
        var totalDias =  29 * mil;
        var timestamp1 = new Date(this.recordatorio1).getTime();
        var fianaltotal= (timestamp1 - mil);
        var dateprueba = new Date(fianaltotal);
        this.recordatorio6 = dateprueba;
        this.recordatorio7=this.recordatorio_aviso1(result,7);// 7 días antes
        if(aux == 1){
          this.labelDate = result.getFullYear()+'/'+mnth+'/'+day;
          this.registerDate(result.getFullYear()+'/'+mnth+'/'+day,this.recordatorio1,this.recordatorio2,this.recordatorio3,this.recordatorio4,this.recordatorio5,this.flagEnvios_second,this.recordatorio6,this.recordatorio7);
        }else if(aux == 2){
          this.labelCierre = this.recordatorio4.getFullYear()+'/'+mnth+'/'+day;
        }else{

        }
      }else{
        this.labelRecordatorio1 = '';
        this.openErrorSnackBar('Por favor, seleccione una fecha','OK');
      }

  }

  agregarFechaRest(result,newresult,newnow,aux){

    var date = new Date(result),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
      var now = new Date();
      var date2 = new Date(now),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
      var moment = require('moment');
      var newnow = moment(now).format('MM/DD/YYYY');
      var newresult = moment(result).format('MM/DD/YYYY');
    if(result != null){
      this.recordatorio3=this.recordatorio_aviso1(result,0); // Lanzamiento de la encuesta
      this.recordatorio4=this.recordatorio_aviso2(result,21); //Fecha de cierre
      this.recordatorio5=this.recordatorio_aviso2(result,51); // REsultados
      if(aux == 1){
        this.labelDate = result.getFullYear()+'/'+mnth+'/'+day;
        this.registerDateRest(result.getFullYear()+'/'+mnth+'/'+day,this.recordatorio3,this.recordatorio4,this.recordatorio5,this.flagEnvios_second);
      }else if(aux == 2){
        this.labelCierre = this.recordatorio4.getFullYear()+'/'+mnth+'/'+day;
      }else{

      }
    }else{
      this.labelRecordatorio1 = '';
      this.openErrorSnackBar('Por favor, seleccione una fecha','OK');
    }

}

  recordatorio_aviso1(fecha,cantDia){
    // Funcipon que sirve para los 3 primeros avisos
    const mil = 86400000;
    var totalDias =  cantDia * mil;
    var timestamp1 = new Date(fecha).getTime();
    var fianaltotal= (timestamp1 - totalDias);
    var dateprueba = new Date(fianaltotal);
    return dateprueba;
  }

  recordatorio_aviso2(fecha,cantDia){
    // Funcipon que sirve para los ultimos dos avisos
    const mil = 86400000;
    var totalDias =  cantDia * mil;
    var timestamp1 = new Date(fecha).getTime();
    var fianaltotal= (timestamp1 + totalDias);
    var dateprueba = new Date(fianaltotal);
    return dateprueba;
  }

  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        this.mensajesTraducirTS[k] = res;
      });
      iter++;
    }
    this.idiomaActual = this.translateSrv.currentLang;
  }
  obtenerIdioma(numError){
    this.idiomaActual = this.translateSrv.currentLang;
    this.getTypeError(numError);
  }
  getTypeError(numError){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        if(k == numError){
          this.mensajesTraducirTS[k] = res;
          this.mensajeSwal(this.mensajesTraducirTS[k],3);
        }
      });
      iter++;
    }
    this.idiomaActual = this.translateSrv.currentLang;
  }
  arrayRemainders:any;
  arrayRemaindersExt:any;
  flagbutton=false;
  Cierrelabel:any;
  bloquearRecordatorios:boolean=false;
  getRecordatoriosFechas(){
    this.getFechaLanzamiento35();
    let dataEnc={
      'fechaNorma35' : this.fechaCertificar35
    };
    this.programacionService.getReminders(dataEnc)
    .subscribe(response => {
      console.log(response);
      if(response['message'] == '200'){
        if(this.arrayRemainders = response['recordatoriosMostrar'].length>0){
          this.flagbutton=true;
          this.dateStatus=true;
          this.arrayRemainders = response['recordatoriosMostrar'];
          if(this.arrayRemainders.length == 3){
            //this.Cierrelabel=this.arrayRemainders[1].fechaRecordatorio;
            //this.labelDate=this.arrayRemainders[0].fechaRecordatorio;
            //this.labelDate=this.labelDate.substring(0,10);
            this.statusFecha=true;
            this.statusTipo2=true;
            this.remaindStatus= true;
            this.getsurveyPilot();
          }else if(this.arrayRemainders.length >= 5){
            console.log("Array de 30 días");
            console.log(this.arrayRemainders);
            ///this.Cierrelabel=this.arrayRemainders[3].fechaRecordatorio;
            //this.labelDate=this.arrayRemainders[2].fechaRecordatorio;
            //this.labelDate=this.labelDate.substring(0,10);
            this.statusFecha=true;
            this.statusTipo=true;
            this.remaindStatus= true;
            this.getsurveyPilot();
          }
        }
        // Parte de recordatorios
        if(this.arrayRemaindersExt = response['recordatoriosN35'].length>0){
          this.arrayRemaindersExt = response['recordatoriosN35'];
          if(this.arrayRemaindersExt.length == 2){

            clearTimeout(1500);
            Swal.fire(
              ' '+this.mensajesTraducirTS.msj15,
              '',
              'warning'
            )

          }
          if(this.arrayRemaindersExt.length >= 3){
            this.bloquearRecordatorios=true;
          }
          // Si tiene 3 recordatorios no puede agregar más

        }
      }
    }, error => {
      console.log(error);
    });
  }
  tmp:any;
  tmp2:any;
  statusClose:boolean=false;
  saverecordatorio(){
    this.traduceTextosTS();
    this.dialogRef = this.dialog.open(Formadialog35Component, {
      data: {}
    });
    this.dialogRef.afterClosed()
      .subscribe(result => {
        var date = new Date(result),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
        if(this.labelDate){
          var timestamp1 = new Date(date).getTime();
          var timestamp2 = new Date(this.Cierrelabel).getTime();
          var timestamp3 = new Date(this.labelDate).getTime();
          if(timestamp1>timestamp3){
            if(timestamp1 < timestamp2){
              this.programacionService.saveRecordatorio(this.productoCertificar35.idNorma35,date)
              .subscribe(response => {
                this.traduceTextosTS();
              Swal.fire(
              ''+this.mensajesTraducirTS.msj13,
              '',
              'success'
              );

                this.getRecordatoriosFechas();
              });

            }else{
              this.traduceTextosTS();
              Swal.fire(

                ''+this.mensajesTraducirTS.msj11,
                '',
                'error',
              );
            }
          }else{
            this.traduceTextosTS();
              Swal.fire(
                ''+this.mensajesTraducirTS.msj14,
                '',
                'error'
              );

          }
        }else{
          this.traduceTextosTS();
          Swal.fire(
            ''+this.mensajesTraducirTS.msj10,
            '',
            'error'
          );
        }
    });
  }

  getsurveyPilot(){
    let dataEnc={
      productoId: this.productoCertificar35.idNorma35
    };

    this.programacionService.obtenerPilito(dataEnc).subscribe((response:backInter.getPilotoN35) => {
      console.log("pilot");
      console.log(response);
      if(response.message == '200'){

      }
      else if(response.success){
        this.pilotSurvey=true;
        this.encuestaOk = true;
        this.usuariosOk = true;
        if(response.urlMas50.length > 1){
          this.mas50Ok = true;
        }
        if(response.urlMenos50.length>1){
          this.menos50Ok = true;
        }
        // if(response.urlCorta.length > 1){
          //   this.urlAutoLogin = response.urlCorta;
          // }
      }
    }, error => {
      console.log(error);
    });
  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }
  flagButton:any;
  flagUsuarios:any;
  flagSeccion1:any;
  flagEncuesta:any;

  flagEncuestaMenos50:any;
  flagEncuestaMas50:any;
  flagUsers:any;
  flagproceso=false;

  velidateBanderas(){
    let datos = {
      productoId: localStorage.getItem('productoID')
    };
    this.service.getBanderas(datos).subscribe((respuesta:backInter.statusReqTec) => {

        console.log(respuesta);
        if(respuesta.success){
          if(respuesta.logo){
            if(respuesta.requerimientos){
              this.createEncuesta();
            }
            else{
              Swal.fire({
                icon: 'error',
                title: this.translateSrv.instant('SHEDULE.ACEPTARREQUERIMIENTOS'),

                confirmButtonText: "OK"
              });
            }
          }
          else{
            Swal.fire({
              icon: 'error',
              title: this.translateSrv.instant('SHEDULE.SUBIRLOGO'),

              confirmButtonText: "OK"
            });
          }
        }

    }, error => {
      console.log(error);
    });

  }

  createEncuesta(){
    console.log("Crear encuesta");
    this.expPanel=true;
    this.pilotSurvey=true;
    this.flagButton = 1;
    this.flagUsuarios = 0;
    this.flagSeccion1 = 0;
    this.flagEncuesta=0;
    this.flagEncuestaMenos50=0;
    this.flagEncuestaMas50=0;
    this.flagUsers=0;
    let data = {
      productoId: this.productoCertificar35.idNorma35
    }

    this.programacionService.crearEncuesta(data)
      .subscribe(response => {

        if(response['success'] == true){
          console.log(response);
          this.flagEncuesta = 1;
          if(response['banderaMas50']==true && response['banderaMenos50']==true){ // IF PARA AMBOS
            this.programacionService.crearEncuesta50(data).subscribe(response => {
                if(response['success'] == true){
                  this.flagEncuesta = 0;
                  this.flagEncuestaMas50=1;
                  console.log("CREACIÓN MÁS DE 50");
                  console.log(response);
                    this.programacionService.crearEncuestamenos50(data).subscribe(response => {
                        if(response['success'] == true){
                          this.flagEncuestaMenos50=1;
                          this.flagEncuestaMas50=0;
                          console.log("Creación MENOS de 50");
                          console.log(response);
                          //CREACIÓN DE USUARIOS PARA PLATAFORMA
                          this.programacionService.saveUsuarios(data).subscribe(response => {
                              this.flagEncuestaMenos50=0;
                              if(response['success'] == true){
                                console.log(response);
                                this.flagUsers=1;
                                this.flagproceso=true;
                                this.flagEncuesta = 2;
                                this.getsurveyPilot();
                                this.modalSurvey();
                              }
                            }, error => {
                              console.log(error);
                            });
                          //FIN DE USUARIOS PARA LA PLATAFORMA
                        }
                        }, error => {
                          console.log(error);
                        });

                }
              }, error => {
                console.log(error);
              });

          }else if(response['banderaMas50']==true){ // IF PARA MÁS DE 50
            this.programacionService.crearEncuesta50(data)
              .subscribe(response => {
                if(response['success'] == true){
                  console.log("Creación más de 50");
                  console.log(response);
                  this.flagEncuestaMas50=1;
                  this.flagEncuesta = 0;
                  //CREACIÓN DE USUARIOS PARA PLATAFORMA
                    this.programacionService.saveUsuarios(data)
                    .subscribe(response => {
                      if(response['success'] == true){
                        console.log(response);
                        this.flagUsers=1;
                        this.flagproceso=true;
                        this.flagEncuesta = 0;
                        this.flagEncuestaMas50=0;
                        this.getsurveyPilot();
                        this.modalSurvey();
                      }
                    }, error => {
                      console.log(error);
                    });
                  //FIN DE USUARIOS PARA LA PLATAFORMA
                }
            }, error => {
              console.log(error);
            });

          }else if(response['banderaMenos50']==true){ // IF PARA BANDERA DE MENOS DE 50
            console.log("entro menos de 50");
            this.programacionService.crearEncuestamenos50(data).subscribe(response => {
                if(response['success'] == true){
                  console.log("Creación MENOS de 50");
                  console.log(response);
                  this.flagEncuestaMenos50=1;
                  this.flagEncuesta = 0;
                    //CREACIÓN DE USUARIOS PARA PLATAFORMA
                    this.programacionService.saveUsuarios(data).subscribe(response => {
                      if(response['success'] == true){
                        console.log(response);
                        this.flagUsers=1;
                        this.flagproceso=true;
                        this.flagEncuesta = 0;
                        this.flagEncuestaMenos50=0;
                        this.getsurveyPilot();
                        this.modalSurvey();
                      }
                    }, error => {
                      console.log(error);
                    });
                  //FIN DE USUARIOS PARA LA PLATAFORMA
                }
            }, error => {
              console.log(error);
            });
          }

        }else{
          console.log("Error");
        }

    }, error => {
      //this.flagEncuesta = 3;
      console.log(error);
    });

  }

  sendUsers(){
    this.flagUsuarios = 1;
    let data = {
      fechaCertificar: this.fechaCertificar35
    }
    this.programacionService.saveUsuarios(data)
      .subscribe(response => {
    }, error => {
      this.flagUsuarios = 3;
      console.log(error);
    });
  }

  modalSurvey(){
    this.flagUsers=2;
    this.traduceTextosTS();
    Swal.fire(
      ''+this.mensajesTraducirTS.msj6,
      '',
      'success'
    );
    this.generaURL();
  }

  generaURL(){
    let datos = {
      producto: '3',
      productoId: this.productoCertificar35.idNorma35,
      urlLarga: DATOS_API.urlSurveyAutologin+"?cm="+this.idEmpresa+"&pr="+3+"&pid="+this.productoCertificar35.idNorma35
      //urlLarga: DATOS_API.urlSurveyAutologin+'/#/'+"?cm="+this.idEmpresa+"&pr="+3+"&pid="+this.productoCertificar35.idNorma35
    };
    console.log(datos);
    this.programacionService.creaUrlAutologin(datos).subscribe((respuesta:backInter.getPilotoN35)=>{
      console.log(respuesta);
    });
  }






}
